import React, { useState } from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import RiskAssessmentDetailsPopup from "./RiskAssessmentDetailsPopup";
import ApproveModal from "../../ApproveModal";

const RiskAssementActionButton = ({
  id,
  setEdit,
  setRiskId,
  toggleShowAddEditRisk,
  sectionType,
  approved,
  approvalPremission,
  fetchRisks,
  setLoading
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const [showApprove, setShowApprove] = useState(false);

  const toggleApproveModal = () => {
    setShowApprove(!showApprove);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {!approved ? (
          <>
            <span>/</span>
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    setEdit(true);
                    toggleShowAddEditRisk();
                    setRiskId(id);
                  }}
                />
              </span>
            </CustomTooltip>
            {/* {approvalPremission ? (
              <>
                <span>/</span>
                <CustomTooltip message={"Approve"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="1x"
                      onClick={() => {
                        toggleApproveModal();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </>
            ) : (
              <></>
            )} */}
          </>
        ) : (
          <></>
        )}
      </span>

      {showView && (
        <RiskAssessmentDetailsPopup
          showView={showView}
          id={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
          sectionType={sectionType}
        />
      )}
      {showApprove && (
        <ApproveModal
          showApprove={showApprove}
          id={id}
          type={"risk_assessment"}
          toggleApproveModal={toggleApproveModal}
          setShowApprove={setShowApprove}
          fetchData={fetchRisks}
          setLoading={setLoading}
        />
      )}
    </>
  );
};

export default RiskAssementActionButton;
